function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39.17 24.43c-1.46 1.72-3.56 3.4-6.2 4.45-.01 0-.11.05-.19.08l.13.13c.55.5 2.02 2.17 1.98 4.91-.04 3.31-2.59 6-5.9 6H13V28h14c7.72 0 14-6.28 14-14S34.72 0 27 0H5v18.01h8v-10h14c3.31 0 6 2.69 6 6s-2.69 6-6 6H5V48h24c7.72.01 14-6.27 14-13.99 0-3.73-1.45-7.08-3.83-9.59v.01z",
  fill: "url(#paint0_linear_1092_5216)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1092_5216",
  x1: "5",
  y1: "48",
  x2: "40.99",
  y2: "12.01",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C815E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#0C72ED"
})))));